import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DateTimeService } from 'src/app/core/services/date-time.service';
import { ShareExportService } from 'src/app/core/services/share-export.service';

@Component({
  selector: 'app-device-location-info',
  templateUrl: './device-location-info.component.html',
  styleUrls: ['./device-location-info.component.scss'],
})
export class DeviceLocationInfoComponent implements OnInit {
  @Input() marker: any;
  @Input() center: string;
  @Input() type: string;
  @Input() cityName: string;
  date: string;
  hour: string;
  constructor(private dateTimeService: DateTimeService, private shareExportService: ShareExportService, private translateService: TranslateService,) { }

  ngOnInit() {
    this.date = this.dateTimeService.formatDate(this.marker.lastSeen, "DD.MM.YYYY");
    this.hour = this.dateTimeService.formatDate(this.marker.lastSeen, "HH:mm");
  }

  shareLocation() {
    let location = this.center
    this.shareExportService.share({
      DialogTitle: this.translateService.instant("detail.field-information"),
      Text: this.cityName,
      Title: this.marker.deviceId,
      Url: "https://maps.google.com/maps?q=" + location[0] + "," + location[1] + "&z=17"
    }).subscribe(res => { });
  }


  openMap() {
    let location = this.center
    this.shareExportService.GetMapTypes(location[0], location[1]);
  }
}
